<template>
  <textarea class="form-control" v-model="innerValue"></textarea>
</template>
<script>
export default {
  name: 'TextAreaRuleInput',
  props: {
    value: String
  },
  data() {
    return { innerValue: null };
  },
  watch: {
    value(newvalue) {
      if (this.innerValue !== newvalue) {
        this.innerValue = newvalue;
      }
    },
    innerValue(newvalue) {
      this.$emit("input", newvalue);
    }
  },
  mounted() {
    this.innerValue = this.value;
  }
};
</script>
<style scoped>
textarea.form-control{
  width:325px ;
}
</style>



// WEBPACK FOOTER //
// src/components/VTextAreaRuleInput.vue